import React, {useState} from 'react';
import {DayPicker} from 'react-day-picker';
import ClickOut from 'react-click-out';
import 'react-day-picker/dist/style.css';
import classnames from 'classnames/bind';
import _ from 'lodash';
import style from './index.module.scss';
import publicImage from '../../utils/publicImage';
import {flatError, valEmpty, valPattern} from '../../utils/validate';
import {EMAIL_PATTERN} from '../../constants';
import moment from 'moment';
import {postBook} from '../../services';
import localesReplacement from '../../utils/localesReplacement';
import {connect} from 'react-redux'; 
import {IState, ITWorkshop, Replacement} from '../../interface';

const cx = classnames.bind(style);
const classFormControl = 'form-control';

export interface IProps {
  dismiss: () => void;
  replacements: Replacement;
  selected: ITWorkshop | undefined;
}

interface Form {
  name?: string;
  email?: string;
  contactNumber?: string;
  typeOfService?: string;
  date?: string;
  promotionalCode?: string;
  signUpForCastrolPromotions?: boolean;
}

interface Error {
  name?: boolean;
  email?: boolean;
  contactNumber?: boolean;
  typeOfService?: boolean;
  date?: boolean;
}

/* eslint-disable */
export const Book = (props: IProps) => {
  const {dismiss,replacements, selected} = props;
  const [open, setOpen] = useState<boolean>(false);
  const [form, setForm] = useState<Form>({
    name: '',
    email: '',
    contactNumber: '',
    typeOfService: '',
    date: '',
    promotionalCode: '',
    signUpForCastrolPromotions: false,
  });
  const [errors, setErrors] = useState<Error>();
  const onSubmit = () => {
    const error = _.assign(
      valEmpty(_.omit(form, 'promotionalCode', 'signUpForCastrolPromotions')),
      valPattern(form.email, 'email')(EMAIL_PATTERN),
    );
    setErrors(error);
    if (flatError(error)) {
      if (selected) {
        postBook(selected.id, form);
        dismiss();
      }
    }
  };
  const onBlur = () => {
    setErrors({});
  };
  return (
    <div className={cx('content')}>
      <span
        className={`button ${cx('close')}`}
        role='button'
        onClick={dismiss}
      ></span>
      <div className={cx('container')}>
        <div className={cx('banner')}>
          <img src={publicImage('contact-banner.jpg')} alt='Banner' />
          <div className={cx('infor')}>
            <h2 title={selected?.name}>{selected?.name}</h2>
            {(_.isEqual(selected?.locationTypes[0].name, 'CPLE') ||
              _.isEqual(selected?.locationTypes[0].name, 'CAS') ||
              _.isEqual(selected?.locationTypes[0].name, 'CS')) && (
              <div className={cx('badge')}>
                {localesReplacement(replacements, 'Castrol RECOMMENDATION')}
              </div>
            )}
          </div>
        </div>
        <div className={cx('form')}>
          <div className={cx('row')}>
            <label>
              {localesReplacement(replacements, 'NAME')}
              <div
                className={cx(classFormControl, {
                  error: _.isEqual(errors?.name, false),
                })}
              >
                <input
                  value={form?.name}
                  onChange={(e) => setForm({...form, name: e.target.value})}
                  onFocus={onBlur}
                />
              </div>
            </label>
          </div>
          <div className={cx('row')}>
            <label>
              {localesReplacement(replacements, 'EMAIL')}
              <div
                className={cx(classFormControl, {
                  error: _.isEqual(errors?.email, false),
                })}
              >
                <input
                  value={form?.email}
                  onChange={(e) => setForm({...form, email: e.target.value})}
                  onFocus={onBlur}
                />
              </div>
            </label>
          </div>
          <div className={cx('row')}>
            <label>
              {localesReplacement(replacements, 'CONTACT NUMBER')}
              <div
                className={cx(classFormControl, {
                  error: _.isEqual(errors?.contactNumber, false),
                })}
              >
                <input
                  value={form?.contactNumber}
                  onChange={(e) =>
                    setForm({...form, contactNumber: e.target.value})
                  }
                  onFocus={onBlur}
                />
              </div>
            </label>
          </div>
          <div className={cx('row')}>
            <label>
              {localesReplacement(replacements, 'TYPE OF SERVICE')}
              <div
                className={cx(classFormControl, {
                  error: _.isEqual(errors?.typeOfService, false),
                })}
              >
                <input
                  value={form.typeOfService}
                  onChange={(e) =>
                    setForm({...form, typeOfService: e.target.value})
                  }
                  onFocus={onBlur}
                />
              </div>
            </label>
          </div>
          <div className={cx('row')}>
            <label>{localesReplacement(replacements, 'DATE')}</label>
            <ClickOut className='click-out' onClickOut={() => setOpen(false)}>
              <div
                className={cx(classFormControl, {
                  error: _.isEqual(errors?.date, false),
                })}
              >
                <div className={cx('date-picker')}>
                  <input
                    readOnly
                    value={form.date}
                    onClick={() => {
                      setOpen(true);
                      onBlur();
                    }}
                  />
                  <i className={cx('calendar')}></i>
                </div>
                {open && (
                  <DayPicker
                    className={cx('daypicker')}
                    mode='single'
                    fromDate={moment().toDate()}
                    selected={moment(form.date).toDate()}
                    onSelect={(day) => {
                      if (day) {
                        setOpen(false);
                        setForm({
                          ...form,
                          date: moment(day).format('YYYY-MM-DD'),
                        });
                      }
                    }}
                  />
                )}
              </div>
            </ClickOut>
          </div>
          <div className={cx('row')}>
            <label>
              {localesReplacement(replacements, 'PROMOTIONAL CODE')}{' '}
              <small>
                ({localesReplacement(replacements, 'if applicable')})
              </small>
              <div className={cx(classFormControl, 'small-form-control')}>
                <input />
              </div>
            </label>
          </div>
          <div className={cx('footer')}>
            <button
              className={`primary-button ${cx('button')}`}
              onClick={onSubmit}
            >
              {localesReplacement(replacements, 'Request an appointment')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
});

export default connect(mapStateToProps)(Book);
